/**
 * FAQ da LP de delivery (home).
 */

module.exports = [
  {
    title: 'Precisa de computador?',
    text: 'Não é necessário ter computador, o sistema também funciona pelo celular e tablet.',
  },
  {
    title: 'A impressora vem junto?',
    text: 'Temos parceria com os melhores fornecedores, entre em contato conosco e solicite o link de indicação para adquirir sua impressora com desconto.',
  },
  {
    title: 'O ZaperMenu é um robô de atendimento?',
    text: 'O ZaperMenu é integrado ao whatsapp e poderá atender mais de 20 clientes ao mesmo tempo, além de enviar o link do Cardápio Digital também avisa seu cliente sobre o status do pedido.',
  },
  {
    title: 'Tem limite de pedidos ou taxas?',
    text: 'Você poderá utilizar o sistema de forma totalmente ilimitada e NÃO cobramos nenhum tipo de taxa sobre os pedidos, você paga apenas o valor do plano contratado.',
  },
  {
    title: 'Em quanto tempo o sistema fica pronto?',
    text: 'O acesso ao sistema é liberado imediatamente, já o cadastramento dos produtos e configurações é realizada por nossos especialistas em menos de 24 horas!',
  },

  // Desativadas no acordeão — se voltarem, voltam para cá (e para o JSON-LD junto):
  // {
  //   title: 'O serviço tem garantia?',
  //   text: 'Você terá 30 dias de garantia incondicional e poderá solicitar o reembolso dentro desse período.',
  // },
  // {
  //   title: 'Terei aumento no faturamento?',
  //   text: 'Com certeza, temos vários recursos para impulsionar as vendas: Disparador de Mensagens no Whatsapp, Venda Complementar, Programa de Fidelidade, Cupons e muito mais.',
  // },
];
